import { HStack, Icon, type IconName, Tab, TabSize, Text } from '@talos/kyoko';
import { TabWrapper } from './styles';

interface TabButtonProps {
  icon: IconName;
  label: string;
  count?: number;
  isActive: boolean;
  onClick: () => void;
}

export function TabButton({ icon, label, count, isActive, onClick }: TabButtonProps) {
  const prefix = (
    <HStack mr="spacing4">
      <Icon icon={icon} size={12} />
    </HStack>
  );

  const suffix =
    count !== undefined ? (
      <Text
        size="fontSizeSmall"
        lineHeight="lineHeightSmall"
        color="colorTextSubtle"
        ml="spacing4"
        px="spacing4"
        background="backgroundCard"
        borderRadius="borderRadiusSmall"
        data-testid={`tab-count-${label.toLowerCase()}`}
      >
        {count}
      </Text>
    ) : undefined;

  return (
    <TabWrapper $isSelected={isActive}>
      <Tab
        label={label}
        isSelected={isActive}
        onClick={onClick}
        size={TabSize.Default}
        prefix={prefix}
        suffix={suffix}
      />
    </TabWrapper>
  );
}
